import { useState, useEffect } from "react";
import { Box, Flex, useBreakpointValue, Text } from "@chakra-ui/react";
import TeamsService from "../services/TeamsService";

export default function Home() {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isDesktop = width > 768;
  const [activeView, setActiveView] = useState<string | null>(
    isDesktop ? "chat" : null,
  );

  const handleBack = () => {
    setActiveView(null);
  };

  const handleViewSelect = (view: string) => {
    if (view === "shifts") {
      console.log("Opening shifts app");
      // Open teams shifts app
      const teamsService = TeamsService.getInstance();
      teamsService.openShiftsApp();
    } else {
      setActiveView(view);
    }
  };

  return (
    <Box>
      <Text>Hello World</Text>
    </Box>
  );
}
